import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from '../store/store';
import axios from "axios"
const fb = require("../firebaseconfig");
Vue.prototype.$axios = axios
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')




axios.interceptors.request.use(async request =>
  {
    
    // Do something before request is sent
    let token = store.state.idToken
    if(token === null){
     let idTokenResult = await fb.auth.currentUser.getIdTokenResult(true);
        token = idTokenResult.token;
        
    }
    request.headers['Authorization'] = `Bearer ${ token }`;
  return request; 
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);